import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./BannerStyle.scss";
const cashImage = require("../../../Assets/Images/canva/embarassed.png");
const Embarassed = () => {
  let { t } = useTranslation();
  return (
    <section id="canvaTip" className="BannerImgSix">
      <Container fluid className="h-100">
        <Row className="align-items-center h-100 px-4">
          <Col md={6} sm={12}>
            <div className="py-3 h-100">
              <h3 className="heading">
                {/* {t("AboutUs")} */}
                Never Feel Embarrassed Again
              </h3>
              <p className="canvaText">
                {/* {t("AboutUsTextFirst")} */}
                Imagine arriving at an event, only to realize you don't have
                small bills to tip the valet. But fear not – That’s where
                EasyTipping comes in! With our cashless tipping app, you can
                effortlessly tip by quickly scanning the QR code on the valet's
                badge, leaving embarrassment behind.
              </p>
              <p className="canvaText py-2">
                Join the triumph. Tip & Go seamlessly with EasyTipping, where
                cashless generosity saves the day!
              </p>
            </div>
          </Col>
          <Col md={6} sm={12}>
            <div className="text-center h-100 mb-2">
              <img className="img-fluid w-75" src={cashImage} alt="" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Embarassed;
